/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeGetInvoicesByIdsRequest, serializeInvoiceDto, type ErrorResponse, type GetInvoicesByIdsRequest, type InternalErrorResponse, type InvoiceDto } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/by-ids
 */
export interface ByIdsRequestBuilder extends BaseRequestBuilder<ByIdsRequestBuilder> {
    /**
     * Fetches several invoices in one round trip instead of calling the single-invoice endpoint repeatedly. Ids that do not exist, or that belong to another organization, are left out of the result rather than failing the call, so the response may be shorter than the list you sent and an empty list of ids returns an empty array. The order of the results is not guaranteed to match the order of the ids.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: GetInvoicesByIdsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto[] | undefined>;
    /**
     * Fetches several invoices in one round trip instead of calling the single-invoice endpoint repeatedly. Ids that do not exist, or that belong to another organization, are left out of the result rather than failing the call, so the response may be shorter than the list you sent and an empty list of ids returns an empty array. The order of the results is not guaranteed to match the order of the ids.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: GetInvoicesByIdsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ByIdsRequestBuilderUriTemplate = "{+baseurl}/api/invoices/by-ids";
/**
 * Metadata for all the requests in the request builder.
 */
export const ByIdsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ByIdsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeGetInvoicesByIdsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
